module.exports = __webpack_public_path__ + "img/tixian.cf46e5e4.png";